module.exports = __webpack_public_path__ + "static/media/logintitle.caf118db.svg";